<div class="my-activities">
  <!-- Loading -->
  <div class="ma-loading" *ngIf="loading">
    <i class="pi pi-spin pi-spinner"></i>
  </div>

  <!-- Empty -->
  <div class="ma-empty" *ngIf="!loading && rows.length === 0">
    <span translate>NO_RECORDS_FOUND</span>
  </div>

  <!-- Every activity is listed; the dashboard box body is the scroll area. -->
  <div class="ma-list" *ngIf="!loading && rows.length > 0">
    <button
      type="button"
      class="ma-row"
      *ngFor="let row of rows"
      (click)="openActivity(row)"
      [title]="row.title"
    >
      <span class="ma-title">{{ row.title }}</span>

      <span class="ma-meta">
        <!-- Every row is an open activity, so the deadline is the only state worth showing:
             a red badge once it is in the past. -->
        <span
          class="ma-date"
          *ngIf="row.deadline"
          [class.ma-date--overdue]="row.overdue"
          [title]="row.overdue ? ('OVERDUE' | translate) : ''"
        >
          <i class="pi pi-calendar"></i>
          {{ row.deadline | date: 'dd/MM/yy' }}
        </span>
      </span>
    </button>
  </div>
</div>
